import { render, staticRenderFns } from "./CreateProductListModal.vue?vue&type=template&id=9f01f2dc"
import script from "./CreateProductListModal.vue?vue&type=script&lang=js"
export * from "./CreateProductListModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports